import { Button, Col } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { Core } from "../../components/infrastructure/core";
import { City } from "../city";
import { IProvince, IProvinceProps, IProvinceStates } from "./interfaces";
import { InFilter } from "../../components/infrastructure/filtering";

export class Province extends EntityManager<IProvince, IProvinceProps, IProvinceStates> {
    cityFormId: string;
    city?: City | null;
    static initMetadata = (): IMetadata => {
        return {
            name: "Province",
            title: "استان",
            Properties: [
                {
                    title: "نام استان",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام استان را وارد نمایید' }]
                },
                {
                    title: "نام لاتین",
                    dataIndex: "NameEn",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showInLookup: false
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }],
                    showInLookup: false
                }
            ]
        };
    }
    constructor(props: IProvinceProps) {
        super(props)
        this.cityFormId = Core.newId();
    }
    onInitializing() {
        this.searchArea = { columnsPerRow: 2 };
        this.searchable = true;
        this.originalFilter = () => {
            const params = this.props.params && this.props.params();
            if (!!params && params.codes?.length) {
                return new InFilter("Code", params.codes);
            }
        };
        this.renderingToolbar = () => {
            let cityAccess = this.initialData?.AccessList["City"];
            if (cityAccess === true) {
                return (
                    <Col style={{ marginLeft: 10 }}>
                        <Button type="default" onClick={this.onCityClick}>شهر ها</Button>
                    </Col>
                );
            }
            return (<></>);
        }
    }
    onCityClick = () => {
        this.addLookupForm("City",
            <City
                key="City"
                invokePath={this.metadata.title}
                isChildComponent={true}
                onClose={this.onLookupClosed}
                params={() => {
                    return { province: this.selectedEntity }
                }}
                ref={node => this.city = node}
            />);
    }
}